<template>
    <el-dialog :visible.sync="show" width="30%" :before-close="closeDialog" :close-on-click-modal="false">
        <el-form>





            <el-form-item label="状态:" label-width='120px'>
                <el-radio-group v-model="submit_data.status">
                    <el-radio-button label="0">未回访</el-radio-button>
                    <el-radio-button label="1">已回访</el-radio-button>
                    <el-radio-button label="2">已签约</el-radio-button>
                </el-radio-group>
            </el-form-item>


            <el-form-item label="备注:" label-width='120px'>
                <el-input style="width: 200px" v-model="submit_data.remarks"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    var _this;
    export default {
        props: {
            'isShow': Boolean,
            'data': ''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;
                _this.submit_data.id = _this.data;


                _this.getDetails()


            }
        },
        data() {
            return {


                show: false,



                // 表单数据
                submit_data: {
                    id: '',
                    remarks: '',
                    status:'',
                },
                submit_rules: {
                    remarks: {
                        placeholder: '备注',
                        rules: {
                            required: true,
                            message: '备注不能为空',
                            regulation: 'gt_str',
                            rulesData: 0
                        }
                    }
                },


            };
        },
        created() {

            _this = this;

        },
        methods: {
            // 获取余额
            getDetails(){

                this.$post(
                    '/recruit/getRecruitDetails', {
                        id: this.submit_data.id
                    }
                ).then(res => {

                    _this.submit_data.remarks = res.data.remarks
                    _this.submit_data.status = res.data.status

                });
            },

            // 关闭方法
            closeDialog() {
                _this.show = false;

                _this.submit_data = {
                    id: '',
                    remarks: '',
                    status:'',
                };

            },
            // 提交
            onSubmit() {
                _this.$post(
                    '/recruit/editRecruit',
                    _this.submit_data,
                    _this.submit_rules
                )
                    .then(res => {

                        _this.$emit('onSubmit');
                        _this.closeDialog();

                        _this.$message.success({
                            message: res.msg,
                            duration: 1500
                        });

                    }).catch(res => {

                });
            }

        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>
